module.exports = __webpack_public_path__ + "media/night/296-05655fd0.svg";